var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0208 15.1667C10.2836 15.1671 10.5438 15.1156 10.7866 15.0152C11.0293 14.9147 11.2499 14.7673 11.4355 14.5814L14.0482 11.9667L13.1055 11.0267L10.6835 13.4493L10.6661 2.5H9.33281L9.35015 13.4387L6.93681 11.0253L5.99414 11.9667L8.60681 14.5794C8.7922 14.7656 9.01255 14.9133 9.25521 15.0141C9.49787 15.1149 9.75805 15.1667 10.0208 15.1667Z",
    fill: "#005C8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 13.1655V16.4989C16.6667 16.6757 16.5965 16.8452 16.4714 16.9703C16.3464 17.0953 16.1768 17.1655 16 17.1655H4C3.82319 17.1655 3.65362 17.0953 3.5286 16.9703C3.40357 16.8452 3.33334 16.6757 3.33334 16.4989V13.1655H2V16.4989C2 17.0293 2.21071 17.538 2.58579 17.9131C2.96086 18.2881 3.46957 18.4989 4 18.4989H16C16.5305 18.4989 17.0392 18.2881 17.4142 17.9131C17.7893 17.538 18 17.0293 18 16.4989V13.1655H16.6667Z",
    fill: "#005C8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.d83fd6c11d3166c748bf395440e36629.svg";
export { ForwardRef as ReactComponent };